
import RadioGroup from './radio-group'

export default RadioGroup



// WEBPACK FOOTER //
// ./src/components/radio-group/index.js